var tags = {
	init: function() {
		if ($('html').find('div[data-regTracking]').length) {
			var  campaignID = $('html').find('div[data-regTracking]').attr('data-regTracking');
			dataLayer.push({
			  'event': 'Registration',
			  'eventCategory': 'Registration',
			  'eventAction': 'Success',
			  'eventLabel' : campaignID
			});
		}

		$('#homepagePanel').click(function() {
			dataLayer.push({
			  'event': 'Widgets',
			  'widgetType': 'Homepage Widget',
			  'widgetAction': 'Submit'
			});
		});
		$('.widget .form-si-submit').click(function() {
			dataLayer.push({
			  'event': 'Widgets',
			  'widgetType': 'Sign-up Widget',
			  'widgetAction': 'Submit'
			});
		});
	}
};